<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            variant="primary"
            @click="showModal('modal-lg')"
          >
            Add
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <!-- <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="invoice-filter-select"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select> -->
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      :items="filteredData"
      responsive
      :fields="tableHeaders"
      primary-key="id"
      show-empty
      no-close-on-backdrop
      empty-text="No interest records available"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="position-relative"
    >

      <template #cell(SN)="data">
        {{ data.index + 1 }}
      </template>
      <!-- Column: Registered Name -->
      <template #cell(registeredName)="data">
        {{ data.value }}
      </template>

      <!-- Column: Primary Email -->
      <template #cell(primaryEmail)="data">
        {{ data.value }}
      </template>

      <!-- Column: CBN Code -->
      <template #cell(cbnCode)="data">
        <p class="mb-0">
          {{ data.value }}
        </p>
      </template>

      <!-- Column: RC Number -->
      <template #cell(rcNumber)="data">
        <p class="mb-0">
          {{ data.value }}
        </p>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="editInstitution(data.item, $event.target)">
              <feather-icon icon="EditIcon" />
              <span
                class="align-middle ml-50"
              >Edit</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>

        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>

            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="okTitle"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="modalTitle"
      @ok="handleSubmit"
    >
      <validation-observer ref="institutionRules">
        <b-form @submit.prevent="createInstitutionAction">
          <b-row class="match-height">
            <!-- Registered Name -->
            <b-col md="6">
              <InputField
                id="registered-name"
                v-model="institutionFormData.registeredName"
                label="Bank's Registered Name"
                placeholder="Enter registered name"
                type="text"
                error-name="Registered Name"
                rules="required"
                for="registered-name"
              />
            </b-col>
            <!-- Registered Name -->

            <!-- Primary Email -->
            <b-col md="6">
              <InputField
                id="primary-email"
                v-model="institutionFormData.primaryEmail"
                label="Bank's Primary Email"
                placeholder="Enter Primary Email"
                type="email"
                error-name="Primary Email"
                rules="required|email"
                for="primary-email"
              />
            </b-col>
            <!-- Primary Email -->
          </b-row>

          <b-row class="match-height">
            <!-- Institution Code -->
            <b-col md="6">
              <InputField
                id="institution-code"
                v-model="institutionFormData.institutionCode"
                label="Bank's Institution/CBN Code"
                placeholder="Enter institution code"
                type="text"
                error-name=" Institution Code"
                rules="required"
                for="institution-code"
              />
            </b-col>
            <!-- Institution Code -->

            <!-- RC Number -->
            <b-col md="6">
              <InputField
                id="rc-number"
                v-model="institutionFormData.rcNumber"
                label="Bank's RC Number"
                placeholder="Enter RC Number"
                type="text"
                error-name="RC Number"
                rules="required"
                for="rc-number"
              />
            </b-col>
            <!-- RC Number -->
          </b-row>

          <b-row class="match-height">
            <!-- Super Admin Email -->
            <b-col md="6">
              <InputField
                id="super-admin-email"
                v-model="institutionFormData.superAdmin"
                label=" Super Admin Email"
                placeholder="Enter super admin email"
                type="text"
                error-name="Super Admin Email"
                rules="required"
                for="super-admin-email"
              />
            </b-col>
            <!-- Super Admin Email -->

            <!-- Primary Contact Name -->
            <b-col md="6">
              <InputField
                id="primary-contact-name"
                v-model="institutionFormData.primaryContactName"
                label="Institution Primary Contact Name"
                placeholder="Enter primary contact name"
                type="text"
                error-name="Primary Contact Name"
                rules="required"
                for="primary-contact-name"
              />
            </b-col>
            <!-- Primary Contact Name -->
          </b-row>

          <b-row class="match-height">
            <!-- Primary Contact Email -->
            <b-col md="4">
              <InputField
                id="primary-contact-email"
                v-model="institutionFormData.primaryContactEmail"
                label="Primary Contact Email"
                placeholder="Enter primary contact email"
                type="email"
                error-name="Primary Contact Email"
                rules="required|email"
                for="primary-contact-email"
              />
            </b-col>
            <!-- Primary Contact Email -->

            <!-- Primary Contact Phone No -->
            <b-col md="4">
              <InputField
                id="primary-contact-number"
                v-model="institutionFormData.primaryContactPhoneNo"
                label="Primary Contact Phone Number"
                placeholder="Enter primary contact number"
                type="text"
                error-name="Primary Contact Number"
                rules="required"
                for="primary-contact-number"
              />
            </b-col>
            <!-- Primary Contact Phone No -->

            <!-- Registered HQ Location -->
            <b-col md="4">
              <SelectField
                id="hq-location"
                v-model="institutionFormData.registeredHQLocation"
                label="Registered HQ Location"
                :options="stateOptions"
                :reduce="option => option.value"
                error-name="Type of Interest"
                rules="required"
                item="label"
              />
            </b-col>
            <!-- Registered HQ Location -->
          </b-row>

          <b-row class="match-height">
            <!-- Registered Address -->
            <b-col md="12">
              <TextAreaField
                id="registered-address"
                v-model="institutionFormData.registeredAddress"
                label="Bank's Registered Address"
                placeholder="Enter  registered address"
                error-name="Registered Address"
                rules="required"
                for="registered-address"
                rows="4"
              />
            </b-col>
            <!-- Registered Address -->
          </b-row>

        </b-form>
      </validation-observer>
    </b-modal>
    <!-- modal -->
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BDropdown, BDropdownItem, BPagination, BModal,
  BForm,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import InputField from '../../forms/InputField.vue'
import TextAreaField from '../../forms/TextAreaField.vue'
import SelectField from '../../forms/SelectField.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    BForm,
    vSelect,
    ValidationObserver,
    InputField,
    TextAreaField,
    SelectField,
  },
  mixins: [modalMixins, tableMixins],
  data() {
    return {
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'registeredName', sortable: true },
        { key: 'primaryEmail', sortable: true },
        { key: 'cbnCode', sortable: true },
        { key: 'rcNumber', sortable: true },
        { key: 'rcNumber', sortable: true },
        { key: 'actions' },
      ],
      required,
      institutionFormData: {
        registeredName: '',
        registeredAddress: '',
        registeredHQLocation: '',
        primaryEmail: '',
        institutionCode: '',
        rcNumber: '',
        superAdmin: '',
        primaryContactName: '',
        primaryContactEmail: '',
        primaryContactPhoneNo: '',
      },
      institutionList: [
        {
          registeredName: 'Access',
          primaryEmail: 'access@mail.com',
          cbnCode: '09876',
          rcNumber: 'RC454335',
          headquarter: 'Victoria Island',
        },
        {
          registeredName: 'UBA',
          primaryEmail: 'uba@mail.com',
          cbnCode: '04576',
          rcNumber: 'RC344335',
          headquarter: 'Marina',
        },
        {
          registeredName: 'Zenith',
          primaryEmail: 'zenith@mail.com',
          cbnCode: '13476',
          rcNumber: 'RC445335',
          headquarter: 'Victoria Island',
        },
        {
          registeredName: 'Wemba',
          primaryEmail: 'wema@mail.com',
          cbnCode: '33876',
          rcNumber: 'RC4558335',
          headquarter: 'Marina',
        },
      ],
      stateOptions: [
        { label: 'Abia', value: 1 },
        { label: 'Adamawa', value: 2 },
        { label: 'Akwa Ibom', value: 3 },
        { label: 'Anambra', value: 4 },
        { label: 'Bauchi', value: 5 },
        { label: 'Bayelsa', value: 6 },
        { label: 'Benue', value: 7 },
        { label: 'Borno', value: 8 },
        { label: 'Cross River', value: 9 },
        { label: 'Delta', value: 10 },
        { label: 'Ebonyi', value: 11 },
        { label: 'Edo', value: 12 },
      ],
      query: '',
    }
  },
  computed: {
    ...mapGetters(['generalLedger/generalLedgerList']),
    total() {
      return this.institutionList.length
    },
    filteredData() {
      return this.institutionList.filter(
        item => (item.registeredName.toLowerCase().includes(this.query.toLowerCase())
        || item.rcNumber.toLowerCase().includes(this.query.toLowerCase())
         || item.headquarter.toLowerCase().includes(this.query.toLowerCase())
         || item.cbnCode.toLowerCase().includes(this.query.toLowerCase())),
      )
    },
  },
  methods: {
    // setSelected(value) {
    //   return value
    // },
    createInstitutionAction(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.institutionRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          // this.$nextTick(() => {
          this.hideModal('modal-lg')
          // })
        }
      })
    },
    updateInstitutionAction() {
      this.$refs.institutionRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
        }
      })
    },
    resetModal() {
      this.chargeFormData.chargeName = ''
      this.chargeFormData.incomeGl = 'Select'
      this.chargeFormData.stationeryGl = 'Select'
      this.chargeFormData.isConsolidateBothAmounts = false
    },
    editInstitution(item) {
      this.institutionFormData.registeredName = item.registeredName
      this.institutionFormData.registeredAddress = item.registeredAddress
      this.institutionFormData.registeredHQLocation = item.registeredHQLocation
      this.institutionFormData.primaryEmail = item.primaryEmail
      this.institutionFormData.institutionCode = item.institutionCode
      this.institutionFormData.rcNumber = item.rcNumber
      this.institutionFormData.superAdmin = item.superAdmin
      this.institutionFormData.primaryContactName = item.primaryContactName
      this.institutionFormData.primaryContactEmail = item.primaryContactEmail
      this.institutionFormData.primaryContactPhoneNo = item.primaryContactPhoneNo
      this.modalTitle = 'Edit Institution'
      this.okTitle = 'Upadte'
      this.$root.$emit('bv::show::modal', 'modal-lg')
    },
    handleSubmit() {
      if (this.okTitle === 'Save') {
        this.createInstitutionAction()
      } else {
        this.updateInstitutionAction()
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
